export default __webpack_public_path__ + "static/media/Cara 9781408355084.6e795eb4.jpg";